/**
 * The keys a swipe card's image owns: the content asset it shows under `slugKey`, the URL a
 * served story resolves from that slug under `urlKey`, and the image's own alt text under
 * `altKey`. The statement is already on the card, so it is never the image's alt text.
 *
 * A URL stored under `urlKey` with no slug is a legacy image: it still shows, but new images
 * come from the content assets.
 */
export const SWIPE_CARD_IMAGE = {
  slugKey: 'contentAssetSlug',
  urlKey: 'imageUrl',
  altKey: 'imageAlt',
} as const;
